import React, { useEffect } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import {
  Box,
  Button,
  Container,
  //   makeStyles,
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  Chip,
  CircularProgress,
  TableFooter,
  TablePagination
} from '@material-ui/core';
import moment from 'moment';
import TablePaginationActions from '../../components/Table/TablePaginationActions';
import SearchBar from 'material-ui-search-bar';

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: '#202340',
    color: theme.palette.common.white
  },
  body: {
    fontSize: 14
  }
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover
    }
  }
}))(TableRow);

function TopupDataTable({
  tableHead,
  tableData,
  className,
  loading
  // handleUpdateRouteStatus,
  // handleUpdateRoute
}) {
  const [searched, setSearched] = React.useState('');
  const [filteredRows, setFilteredRows] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const emptyRows =
    rowsPerPage -
    Math.min(rowsPerPage, filteredRows.length - page * rowsPerPage);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const indexedTableData =
    tableData &&
    tableData.map((item, index) => {
      return { ...item, index: index + 1 };
    });

  const paymentMethod = (value) => {
    switch (value) {
      case '-1':
        return 'System Topup';
      case '1':
        return 'Transfer';
      case '2':
        return 'Paystack';
      default:
        return 'Invalid';
    }
  };

  useEffect(() => {
    setFilteredRows(tableData);
  }, [tableData]);

  const requestSearch = (searchedValue) => {
    const filterRows =
      tableData &&
      tableData.filter((row) => {
        const result = row?.reference
          ?.toLowerCase()
          ?.includes(searchedValue.toLowerCase());
        return result;
      });
    setFilteredRows(filterRows);
    if (searchedValue === '') {
      setFilteredRows(tableData);
    }
  };

  const cancelSearch = () => {
    setSearched('');
    requestSearch(searched);
    setFilteredRows(tableData);
  };

  return (
    <>
      <div className={className.searchBar}>
        <SearchBar
          value={searched}
          onChange={(searchedVal) => requestSearch(searchedVal)}
          onCancelSearch={() => cancelSearch()}
          placeholder="Search by Transaction ID"
        />
      </div>
      <TableContainer className={className.datatable} component={Paper}>
        <Table className={className.table}>
          <TableHead>
            <TableRow>
              {tableHead.map((item, index) => (
                <StyledTableCell key={index} align="center">
                  {item.title}
                </StyledTableCell>
              ))}
            </TableRow>
          </TableHead>
          {!loading ? (
            <TableBody>
              {tableData.length !== 0 ? (
                (filteredRows.length > 0
                  ? filteredRows.slice(
                      page * rowsPerPage,
                      page * rowsPerPage + rowsPerPage
                    )
                  : filteredRows
                ).map((item, index) => (
                  <StyledTableRow key={index}>
                    <TableCell> {item.index} </TableCell>
                    <TableCell align="center"> {item?.customerName} </TableCell>
                    <TableCell align="center"> {item.reference} </TableCell>
                    <TableCell align="center"> {item.amount} </TableCell>
                    <TableCell align="center">
                      {' '}
                      {paymentMethod(item.method)}{' '}
                    </TableCell>
                    <TableCell align="center">
                      {' '}
                      {item.narration ? item.narration : '-'}{' '}
                    </TableCell>
                    <TableCell align="center">
                      {' '}
                      {item.status < 0 ? (
                        <Chip
                          variant="outlined"
                          color="secondary"
                          size="small"
                          label="Failed"
                        />
                      ) : (
                        <Chip
                          style={{ background: 'green', color: 'white' }}
                          size="small"
                          label="Successful"
                        />
                      )}{' '}
                    </TableCell>
                    {/* <TableCell align="center"> {item.cost} </TableCell> */}
                    <TableCell align="center">
                      {' '}
                      {moment(item.transDate * 1000).format('DD-MM-YYYY')}{' '}
                    </TableCell>
                  </StyledTableRow>
                ))
              ) : (
                <StyledTableRow>
                  <TableCell> </TableCell>
                  {/* {loading ? <CircularProgress /> : <TableCell> </TableCell>} */}
                </StyledTableRow>
              )}
            </TableBody>
          ) : (
            <TableBody>
              <StyledTableRow>
                <TableCell>
                  <CircularProgress size="1rem" />
                </TableCell>
              </StyledTableRow>
            </TableBody>
          )}

          <TableFooter>
            <TableRow>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                colSpan={3}
                count={filteredRows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                SelectProps={{
                  inputProps: { 'aria-label': 'rows per page' },
                  native: true
                }}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>
    </>
  );
}

export default TopupDataTable;
